import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigationUtils, useRestrictedCard } from '@mssgme/hooks';
import { Feature, NavBackButton, ScrollableBox, SidebarHeader } from '@mssgme/ui';
import { FieldTip } from '@mssgme/app/components/UI';

import ListItem from './ListItem';
import { PageLayout } from '../../../UI';

import styles from './styles.scss';

export function PageTrackingMenu() {
    const { t } = useTranslation('cards');
    const { generateUrl } = useNavigationUtils();
    const restrictedCard = useRestrictedCard();
    const {
        analytics: { facebook, google, yandex },
    } = restrictedCard;

    return (
        <PageLayout>
            <SidebarHeader
                heading={t('PageTrackingMenu.title')}
                leftButton={<NavBackButton to={generateUrl('..')} />}
            />
            <ScrollableBox className={styles.scrollBox}>
                <Feature rule="tracking">
                    <ul className={styles.list}>
                        <ListItem to={generateUrl('facebook')} name={t('PageTrackingMenu.menu.facebook')}>
                            <div className={styles.textPreview}>{facebook || t('PageTrackingMenu.values.empty')}</div>
                        </ListItem>
                        <ListItem to={generateUrl('google')} name={t('PageTrackingMenu.menu.google')}>
                            <div className={styles.textPreview}>{google || t('PageTrackingMenu.values.empty')}</div>
                        </ListItem>
                        <ListItem to={generateUrl('yandex')} name={t('PageTrackingMenu.menu.yandex')}>
                            <div className={styles.textPreview}>{yandex || t('PageTrackingMenu.values.empty')}</div>
                        </ListItem>
                    </ul>
                    <FieldTip style={{ marginTop: 16 }}>{t('FieldTip.tracking')}</FieldTip>
                </Feature>
            </ScrollableBox>
        </PageLayout>
    );
}
